import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as _108 from "./applications/transfer/v1/genesis";
import * as _109 from "./applications/transfer/v1/query";
import * as _110 from "./applications/transfer/v1/transfer";
import * as _111 from "./applications/transfer/v1/tx";
import * as _112 from "./applications/transfer/v2/packet";
import * as _113 from "./core/channel/v1/channel";
import * as _114 from "./core/channel/v1/genesis";
import * as _115 from "./core/channel/v1/query";
import * as _116 from "./core/channel/v1/tx";
import * as _117 from "./core/client/v1/client";
import * as _118 from "./core/client/v1/genesis";
import * as _119 from "./core/client/v1/query";
import * as _120 from "./core/client/v1/tx";
import * as _121 from "./core/commitment/v1/commitment";
import * as _122 from "./core/connection/v1/connection";
import * as _123 from "./core/connection/v1/genesis";
import * as _124 from "./core/connection/v1/query";
import * as _125 from "./core/connection/v1/tx";
import * as _126 from "./core/port/v1/query";
import * as _127 from "./core/types/v1/genesis";
import * as _128 from "./lightclients/localhost/v1/localhost";
import * as _129 from "./lightclients/solomachine/v1/solomachine";
import * as _130 from "./lightclients/solomachine/v2/solomachine";
import * as _131 from "./lightclients/tendermint/v1/tendermint";
import * as _263 from "./applications/transfer/v1/tx.amino";
import * as _264 from "./core/channel/v1/tx.amino";
import * as _265 from "./core/client/v1/tx.amino";
import * as _266 from "./core/connection/v1/tx.amino";
import * as _267 from "./applications/transfer/v1/tx.registry";
import * as _268 from "./core/channel/v1/tx.registry";
import * as _269 from "./core/client/v1/tx.registry";
import * as _270 from "./core/connection/v1/tx.registry";
import * as _271 from "./applications/transfer/v1/query.lcd";
import * as _272 from "./core/channel/v1/query.lcd";
import * as _273 from "./core/client/v1/query.lcd";
import * as _274 from "./core/connection/v1/query.lcd";
import * as _275 from "./applications/transfer/v1/query.rpc.query";
import * as _276 from "./core/channel/v1/query.rpc.query";
import * as _277 from "./core/client/v1/query.rpc.query";
import * as _278 from "./core/connection/v1/query.rpc.query";
import * as _279 from "./core/port/v1/query.rpc.query";
import * as _280 from "./applications/transfer/v1/tx.rpc.msg";
import * as _281 from "./core/channel/v1/tx.rpc.msg";
import * as _282 from "./core/client/v1/tx.rpc.msg";
import * as _283 from "./core/connection/v1/tx.rpc.msg";
export let ibc;

(function (_ibc) {
  let applications;

  (function (_applications) {
    let transfer;

    (function (_transfer) {
      const v1 = _transfer.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _108), _109), _110), _111), _263), _267), _271), _275), _280);

      const v2 = _transfer.v2 = _objectSpread({}, _112);
    })(transfer || (transfer = _applications.transfer || (_applications.transfer = {})));
  })(applications || (applications = _ibc.applications || (_ibc.applications = {})));

  let core;

  (function (_core) {
    let channel;

    (function (_channel) {
      const v1 = _channel.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _113), _114), _115), _116), _264), _268), _272), _276), _281);
    })(channel || (channel = _core.channel || (_core.channel = {})));

    let client;

    (function (_client) {
      const v1 = _client.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _117), _118), _119), _120), _265), _269), _273), _277), _282);
    })(client || (client = _core.client || (_core.client = {})));

    let commitment;

    (function (_commitment) {
      const v1 = _commitment.v1 = _objectSpread({}, _121);
    })(commitment || (commitment = _core.commitment || (_core.commitment = {})));

    let connection;

    (function (_connection) {
      const v1 = _connection.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _122), _123), _124), _125), _266), _270), _274), _278), _283);
    })(connection || (connection = _core.connection || (_core.connection = {})));

    let port;

    (function (_port) {
      const v1 = _port.v1 = _objectSpread(_objectSpread({}, _126), _279);
    })(port || (port = _core.port || (_core.port = {})));

    let types;

    (function (_types) {
      const v1 = _types.v1 = _objectSpread({}, _127);
    })(types || (types = _core.types || (_core.types = {})));
  })(core || (core = _ibc.core || (_ibc.core = {})));

  let lightclients;

  (function (_lightclients) {
    let localhost;

    (function (_localhost) {
      const v1 = _localhost.v1 = _objectSpread({}, _128);
    })(localhost || (localhost = _lightclients.localhost || (_lightclients.localhost = {})));

    let solomachine;

    (function (_solomachine) {
      const v1 = _solomachine.v1 = _objectSpread({}, _129);

      const v2 = _solomachine.v2 = _objectSpread({}, _130);
    })(solomachine || (solomachine = _lightclients.solomachine || (_lightclients.solomachine = {})));

    let tendermint;

    (function (_tendermint) {
      const v1 = _tendermint.v1 = _objectSpread({}, _131);
    })(tendermint || (tendermint = _lightclients.tendermint || (_lightclients.tendermint = {})));
  })(lightclients || (lightclients = _ibc.lightclients || (_ibc.lightclients = {})));
})(ibc || (ibc = {}));